import { FC, memo } from 'react';

import { ImgProps } from '../types/img';
import Img from './Img';

const SX_IMAGE = {
  borderRadius: '50%',
  marginX: 'auto',
  maxWidth: { md: '250px', xs: '200px' },
  width: '100%',
};

const ProfileImg: FC<ImgProps> = ({ sx, ...props }) => (
  <Img {...props} sx={{ ...sx, ...SX_IMAGE }} />
);

export default memo(ProfileImg);
